import React from 'react';
import ReactDOM from 'react-dom/client';
import './assests/css/reset.css';
import './assests/css/config.css';
import App from './App';

/**
 * App root.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
